import { requestApi } from 'api/api'
import type {
  Limit,
  LimitsQueryParams,
  LimitsResponse,
  UpdateLimitPayload,
} from 'types/paymentLimits'

export const getPaymentLimits = async (params: LimitsQueryParams): Promise<LimitsResponse> => {
  return requestApi({
    url: '/governance/v1/limits',
    method: 'GET',
    params,
  })
}

export const updatePaymentLimit = async ({
  ruleId,
  ...data
}: UpdateLimitPayload): Promise<Limit> => {
  return requestApi({
    url: `/governance/v1/limits/${ruleId}`,
    method: 'PUT',
    data,
  })
}
